module.exports = __webpack_public_path__ + "img/sixu2.1ecef985.png";